"use strict";

var _AsyncBoundary;
import { SectionLoading } from '@autoguru/components';
import { StandardModal } from '@autoguru/overdrive';
import { StaticMFEShadowedComponent } from '@autoguru/static-mfe/static-mfe-shadowed-component';
import { AsyncBoundary } from '@autoguru/suspense';
import * as styles from './SupportHeaderModal.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SupportHeaderModal = ({
  showModal,
  changeState
}) => {
  return /*#__PURE__*/_jsx(StandardModal, {
    onRequestClose: () => changeState(),
    isOpen: showModal,
    className: styles.container,
    title: "",
    children: showModal && (_AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
      fallback: SectionLoading,
      children: /*#__PURE__*/_jsx(StaticMFEShadowedComponent, {
        width: "full",
        mfeAppName: "gb-support-contact"
      })
    })))
  });
};